<template lang="pug">
.tournament-betslip-footer
  .tournament-betslip-title.d-flex.justify-content-between(
    data-bs-toggle="collapse"
    :data-bs-target="'#betslip-' + roomData.room_id "
    aria-expanded='true'
    :aria-controls="'betslip-' + roomData.room_id"
    @click="collapseBetSlip(roomData.room_id)"
  ) 
    | {{ $t('ui.bet_slip') }} - {{ $t('ui.room') }}: {{ roomData.room_id }} 
    .tournament-arrow
      i.fas.ml-2.fa-chevron-down 
  .tournament-betslip-content.collapse.show(:id="'betslip-' + roomData.room_id")
    template(v-if="data != ''")
      .tournament-betslip-footer-wrapper.mb-2(
        v-for="m in data"
        :key="'tournament-betslip-single-' + bs[m].match.match_id"
        :id="'tournament-betslip-single-' + bs[m].match.match_id"
      )
        .tournament-mybet-single
          .tournament-mybet-title {{ sportsType[bs[m].sports_type] }} - {{ $t('m.BS_' + bs[m].bet_type) }}
          //- .tournament-mybet-status.text-dkgreen Accepted
          .tournament-mybet-wrapper
            .tournament-mybet-odds
              .tournament-mybet-odds-left
                .tournament-mybet-text.mb-0(v-if="['HDP','HDPH'].includes(bs[m].bet_type)")
                  b(v-if="bs[m].home_away == 1") {{ getName('home_name', bs[m].match) }}
                  b(v-else) {{ getName('away_name', bs[m].match) }}
                .tournament-odds-text.mb-0(v-else)
                  b(v-if="bs[m].home_away == 1") {{ $t('ui.over') }}
                  b(v-else) {{ $t('ui.under') }}
                //- .tournament-color-red.mx-1 @
                //- .tournament-mybet-text.mb-0 0.97
              .tournament-mybet-odds-right
                .tournament-odds-text {{ bs[m].ball_value }}
                .tournament-color-red.mx-1 @
                .tournament-odds-text {{ bs[m].value }}
              //- .tournament-mybet-odds-right
              //-   .tournament-mybet-text.mb-0 MYR 5.00
            .d-flex.align-items-center
              .tournament-mybet-small.col-5 {{ getName('home_name', bs[m].match) }} 
              span.tournament-vs.col-2.text-center &nbsp;-vs-&nbsp;
              .tournament-mybet-small.col-5 {{ getName('away_name', bs[m].match) }}
            //- .tournament-mybet-details
            //-   .tournament-mybet-tiny  {{ $t("ui.id") }}: {{ bs[m].match.match_id }}
      .empty
        .note
          | {{ $t('message.must_accept_better_odds') }}
      .tournament-stake-wrapper
      .tournament-betslip-btn
        .input-group
          span.input-group-text
            img(src='/images/tournament/icon-point.svg')
          StakeInput2(v-model="stake", @handleStake="handleStake", ref="stake", :loadbet="loading.betPlus")
        button.tournament-btn-bet-amount(@click="fastInput(100)") 100
        button.tournament-btn-bet-amount(@click="fastInput(300)") 300
        button.tournament-btn-bet-amount(@click="fastInput(500)") 500
        //- button.tournament-btn-bet-allin(@click="fastInput()") ALL IN
      .tournament-table-entry
        div {{ $t("ui.min") }}: {{ $numeral(minBet).format("0,0.00") }} | {{ $t("ui.max") }}: {{ $numeral(maxBet).format("0,0.00") }}
        div {{ $t("ui.payout") }}: {{ $numeral(payout).format("0,0.00") }}
      .d-flex.justify-content-between
        button.tournament-btn-cancel(@click="cancel") {{ $t('ui.cancel') }}
        button.tournament-btn-bet(@click="placeBet" :disabled="(total <= 0) || (stake <= 0) || loading.betPlus")
          template(v-if="loading.betPlus")
            i.fad.fa-spinner-third.fa-spin
          template(v-else)
            span {{ $t('ui.process_bet') }}
    template(v-else)
      .empty
        p
          | {{ $t("message.bet_empty") }}
        .note
          | {{ $t('message.must_accept_better_odds') }}
    //- .tournament-stake-wrapper
    //-   .tournament-betslip-btn
    //-     .input-group
    //-       span.input-group-text
    //-         img(src='/images/tournament/icon-point.svg')
    //-       StakeInput2(v-model="stake", @handleStake="handleStake", ref="stake", :loadbet="loading.betPlus")
    //-     button.tournament-btn-bet-amount(@click="fastInput(100)") 100
    //-     button.tournament-btn-bet-amount(@click="fastInput(300)") 300
    //-     button.tournament-btn-bet-amount(@click="fastInput(500)") 500
    //-     //- button.tournament-btn-bet-allin(@click="fastInput()") ALL IN
    //-   .tournament-table-entry
    //-     div {{ $t("ui.min") }}: {{ $numeral(minBet).format("0,0.00") }} | {{ $t("ui.max") }}: {{ $numeral(maxBet).format("0,0.00") }}
    //-     div {{ $t("ui.payout") }}: {{ $numeral(payout).format("0,0.00") }}
    //-   .d-flex.justify-content-between
    //-     button.tournament-btn-cancel(@click="cancel") {{ $t('ui.cancel') }}
    //-     button.tournament-btn-bet(@click="placeBet" :disabled="(total <= 0) || (stake <= 0) || loading.betPlus")
    //-       template(v-if="loading.betPlus")
    //-         i.fad.fa-spinner-third.fa-spin
    //-       template(v-else)
    //-         span {{ $t('ui.process_bet') }}
</template>

<script>
import config from "@/config";
import errors from "@/errors";
import { EventBus } from "@/library/_event-bus.js";
import service from "@/views/tournament/library/_xhr.js";
import xhrBet from "@/library/_xhr-bet.js";
import calc from "@/library/_calculation.js";
import StakeInput2 from "@/views/tournament/library/stakeInput2";

const _INTERVAL = 60;

export default {
  components: {
    StakeInput2
  },
  props: {
    roomId: {
      type: Number
    },
    showBetSlip: {
      type: Boolean
    }
  },
  data() {
    return {
      roomData: {},
      debCheck: null,
      loading: {
        betPlus: false
      },
      betSlip: {},
      acceptBetterOdds: true,
      data: [],
      defaultMinBet: 100,
      defaultMaxBet: 500,
      minBet: this.defaultMinBet,
      maxBet: this.defaultMaxBet,
      stake: this.defaultMinBet
    };
  },
  computed: {
    payout() {
      if (this.data.length == 1) {
        var v = this.bs[this.data[0]].value;
        var a = this.stake * v;
        var b = this.maxBet * v;
        if (a > b) {
          a = b;
        }
        return a.toFixed(3);
      } else {
        return 0;
      }
    },
    bs() {
      var e = this.roomData.room_id;
      if (e == undefined) {
        return {};
      }

      if (this.betSlip.hasOwnProperty(e)) {
        return this.betSlip[e];
      } else {
        return {};
      }
    },
    total() {
      var e = this.roomData.room_id;
      if (e == undefined) {
        return -1;
      }
      // return total count of betSlip keys
      if (this.betSlip[e] == null) {
        return -1;
      } else {
        return Object.keys(this.betSlip[e]).length;
      }
    },
    commType() {
      return this.$store.getters.commType;
    },
    oddsType() {
      return this.$store.getters.pageDisplay.oddsType;
    },
    language() {
      return this.$store.getters.language;
    },
    sportsType() {
      return this.$store.state.layout.sports;
    }
  },
  watch: {
    showBetSlip(val) {
      if (val === false) {
        $("#betslip-" + this.roomData.room_id).collapse("hide");
        this.collapseBetSlip(this.roomData.room_id);
        this.cancel();
      }
    }
  },
  destroyed() {
    EventBus.$off("ROOM_DATA", this.setRoomData);
    EventBus.$emit("selectOdds", this.betSlip);
  },
  mounted() {
    EventBus.tournamentAdd = this.addSlip;
    this.debCheck = this.debounce(this.getMultiBetCheck, 250);
    this.getData();
    EventBus.$on("ROOM_DATA", this.setRoomData);
    EventBus.$emit("selectOdds", this.betSlip);

    this.handleTimer();
    this.handleStake(true);
  },
  methods: {
    closeMe() {
      this.$emit("betslip-close");
    },
    fastInput(e, skip) {
      if (this.roomData.total_points == null) {
        this.minBet = 0;
        this.maxBet = 0;
        this.stake = 0;
      } else {
        this.minBet = this.defaultMinBet;
        var max = Number(this.roomData.total_points);
        if (max > this.defaultMaxBet) {
          max = this.defaultMaxBet;
        }
        this.maxBet = max;
        if (this.minBet > this.maxBet) {
          this.minBet = this.maxBet;
        }

        var val = e;
        if (val == undefined) {
          val = this.maxBet;
        } else {
          if (val < this.minBet) {
            val = this.minBet;
          }
          if (val > this.maxBet) {
            val = this.maxBet;
          }
        }

        this.stake = val;

        if (this.stake > this.maxBet) {
          this.stake = this.maxBet;
          if (skip == undefined) {
            this.$helpers.handleFeedback("changeStakeMax");
          }
        } else {
          if (this.stake < this.minBet) {
            this.stake = this.minBet;
            if (skip == undefined) {
              this.$helpers.handleFeedback("changeStakeMin");
            }
          }
        }
      }
    },
    handleStake(skip) {
      if (this.roomData.total_points == null) {
        this.minBet = 0;
        this.maxBet = 0;
        this.stake = 0;
      } else {
        this.minBet = this.defaultMinBet;
        var max = Number(this.roomData.total_points);
        if (max > this.defaultMaxBet) {
          max = this.defaultMaxBet;
        }
        this.maxBet = max;
        if (this.minBet > this.maxBet) {
          this.minBet = this.maxBet;
        }
        if (this.stake > this.maxBet) {
          this.stake = this.maxBet;
          if (skip == undefined) {
            this.$helpers.handleFeedback("changeStakeMax");
          }
        } else {
          if (this.stake < this.minBet) {
            this.stake = this.minBet;
            if (skip == undefined) {
              this.$helpers.handleFeedback("changeStakeMin");
            }
          }
        }
      }
    },
    handleTimer() {
      this.handler = setTimeout(() => {
        this.refreshCheck();
        this.handleTimer();
      }, 5000);
    },
    leaveRoom() {
      this.$emit("room-leave");
    },
    refreshCheck() {
      if (this.debCheck) {
        this.debCheck();
      }
    },
    getData() {
      this.getMultiBetCheck();
    },
    setRoomData(e) {
      if (e.room_id == this.roomId) {
        this.$set(this, "roomData", e);
        this.getData();
        this.handleStake(true);
      } else {
        this.roomData = {};
      }
    },
    debounce(func, wait, immediate) {
      var timeout;

      return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
      };
    },
    placeBet() {
      if (![0, 1].includes(this.roomData.room_status)) {
        console.log("skip");
        return;
      }

      var e = this.roomData.room_id;
      if (e == undefined) {
        return;
      }

      // var details = [];
      for (var n in this.betSlip[e]) {
        var m = this.betSlip[e][n];
        var item = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          room_id: e,
          bet_member: this.stake,
          accept_better_odds: true,

          odds_id: m.odds[3],
          submatch_id: m.odds[2],
          match_id: m.odds[1],
          bet_type: m.odds[4],
          bet_member: this.stake,
          bet_team_id: m.home_away == 1 ? m.match.home_team_id : m.match.away_team_id,
          home_away: m.home_away,
          odds_display: parseFloat(m.value),
          odds_mo: parseFloat(m.origin),
          odds_type: config.oddsTypeId[m.typ],
          ball_display: m.odds[8]
        };
        this.betPlus(item);
      }

      this.cancel();
    },
    betPlus(json) {
      var feedback = {
        success: false,
        status: errors.session.invalidSession
      };

      this.loading.betPlus = true;
      service.bet(config.tournamentUrl().betplus, json).then(
        result => {
          this.loading.betPlus = false;
          EventBus.$emit("roomGameRefresh");

          if (result) {
            feedback.success = result.success;
            feedback.status = result.status;
            if (result.success == false) {
              this.$helpers.handleFeedback(feedback.status);
            }
          }
        },
        err => {
          console.log(err);
          this.loading.betPlus = false;
          feedback.success = false;
          feedback.status = errors.request.failed;
          this.$helpers.handleFeedback(err.status);
        }
      );
    },
    cancel() {
      var e = this.roomData.room_id;
      if (e == undefined) {
        return {};
      }

      // use $set to set betSlip to a new object by room_id
      this.data = [];
      this.$set(this.betSlip, e, {});
      EventBus.$emit("selectOdds", this.betSlip);
    },
    highlighting(match_id, timing) {
      $(".tournament-betslip-single").removeClass("tournament-betslip-highlight");
      setTimeout(() => {
        $("#tournament-betslip-single-" + match_id).addClass("tournament-betslip-highlight");
      }, 100);
      setTimeout(() => {
        $("#tournament-betslip-single-" + match_id).removeClass("tournament-betslip-highlight");
      }, timing);
    },
    addSlip(e) {
      if (this.maxBet <= 0) {
        console.log("skip");
        return;
      }
      if (![0, 1].includes(this.roomData.room_status)) {
        console.log("skip");
        return;
      }
      if (e.home_away < 0) {
        console.log("invalid home_away value");
        return;
      }
      var roomId = this.roomData.room_id;
      if (roomId == undefined) {
        return {};
      }
      if (roomId != this.roomId) {
        console.log("room_id not match");
        return;
      }

      $("#betslip-" + this.roomData.room_id).collapse("show");
      this.collapseBetSlip(this.roomData.room_id);
      // check if betSlip is empty by room_id, if yes, create a new object
      if (this.betSlip[roomId] == null) {
        this.$set(this.betSlip, roomId, {});
      } else {
        this.betSlip[roomId] = {};
      }

      this.$set(this.betSlip[roomId], e.match.match_id, e);
      this.highlighting(e.match.match_id, 2000);
      EventBus.$emit("selectOdds", this.betSlip);

      this.data = [e.match.match_id];
    },
    collapseBetSlip(e) {
      if ($('.tournament-betslip-title[data-bs-target="#betslip-' + e + '"] ').hasClass("collapsed") === true) {
        this.$emit("show-overlay", false);
        $('.tournament-betslip-title[data-bs-target="#betslip-' + e + '"] .tournament-arrow i')
          .removeClass("fa-chevron-down")
          .addClass("fa-chevron-up");
      } else {
        this.$emit("show-overlay", true);
        $('.tournament-betslip-title[data-bs-target="#betslip-' + e + '"] .tournament-arrow i')
          .addClass("fa-chevron-down")
          .removeClass("fa-chevron-up");
      }
    },
    getLeagueName(e) {
      var name = e["name_" + this.language];
      if (name == null || name == "" || !name) {
        name = e.league_name;
      }
      return name;
    },
    getTeamName(p, e) {
      var name = e[p + "_name_" + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "_team_name"];
      }
      return name;
    },
    getName(p, e) {
      var name = e[p + "_" + this.language];
      if (name == null || name == "" || !name) {
        name = e[p + "_en"];
      }
      return name;
    },
    getLogo(p, e) {
      return config.flagPath + p + "/" + e;
    },
    getMultiBetCheck() {
      var e = this.roomData.room_id;
      if (e == undefined) {
        return {};
      }

      var parlay = [];
      for (var n in this.data) {
        var data = this.betSlip[e][this.data[n]];
        if (data && data.hasOwnProperty("sports_type")) {
          var item = {
            sports_type: data.sports_type,
            parlay: false,
            odds_id: data.odds[3],
            submatch_id: data.odds[2],
            bet_type: data.bet_type,
            bet_team_id: data.home_away == 1 ? data.match.home_team_id : data.match.away_team_id,
            home_away: data.home_away,
            odds_display: parseFloat(data.value),
            odds_mo: parseFloat(data.origin),
            odds_type: config.oddsTypeId[data.typ],
            ball_display: data.odds[8]
          };
          parlay.push(item);
        }
      }

      if (parlay.length <= 0) {
        return;
      }

      var slip = {
        account_id: this.$store.getters.accountId,
        session_token: this.$store.getters.sessionToken,
        parlay: parlay
      };

      xhrBet.betMultiOddsCheck(slip).then(
        res => {
          if (res.success) {
            var results = res.data;
            for (var n in this.data) {
              var m = this.betSlip[e][this.data[n]];
              var r = results[n];

              var d = r.odds_check_details[0];
              var success = false;
              if (typeof r.status == "string") {
                success = r.status == "1";
              } else {
                success = r.status == 1;
              }

              if (success) {
                if (m.odds[3] && m.odds[3] == d.odds_id) {
                  if (d.home_giving == true) {
                    m.giving = 1;
                  } else {
                    m.giving = 0;
                  }
                  if (d.ball_display_new != null) {
                    m.odds[8] = d.ball_display_new;
                  }
                  if (d.ball_new != null) {
                    var bd = d.ball_new;
                    if (m.home_away != m.giving + 1) {
                      if (bd != 0) {
                        bd = "-" + bd.toString();
                      }
                    }
                    m.ball_value = bd;
                  }
                  if (d.odds_display_new != null) {
                    m.value = calc.fmtType(d.odds_display_new, "A", m.bet_type);
                  }
                  if (d.odds_new != null) {
                    m.origin = calc.fmt(d.odds_new);
                  }
                  if (d.ball_new != null || d.odds_new != null) {
                    this.highlighting(m.match.match_id, 2000);
                  }
                }
              }
            }
          } else {
            this.$helpers.handleFeedback(res.status);
          }
        },
        err => {
          this.$helpers.handleFeedback(err.status);
        }
      );
    }
  }
};
</script>
